import React, { useState, useEffect, useRef } from 'react';

import classNames from 'classnames';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { FilterMatchMode, FilterOperator } from 'primereact/api';

import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { Skeleton } from 'primereact/skeleton';
//import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { MultiSelect } from 'primereact/multiselect';

import { GenericaSistemaService } from '../../service/GenericaSistemaService';
import { PlantillaService } from '../../service/PlantillaService';

import AuthStorage from '../../storage/AuthStorage';
import { locale, addLocale } from 'primereact/api';
import lodash from "lodash";

const DataTableListGenerica = React.forwardRef((props, ref) => {
    console.log("DataTableListGenerica");
    //= (props) => {

    //console.log("DataTableGenerica, ");

    const dt = useRef(null);

    const codModulo = "DATATABLE_GENERICA";
    const _ = lodash;

    const plantillaService = new PlantillaService();
    const genericaSistemaService = new GenericaSistemaService();

    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();

    const { userName, idEmpresa, idioma, sessionGUID } = userDetails;

    const [etiquetasModulo, setEtiquetasModulo] = useState([]);

    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [validaData, setValidaData] = useState(false);

    const [searchTextBase, setSearchTextBase] = useState('');
    const [ctiTextoSearchTextBase, setCtiTextoSearchTextBase] = useState('');

    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);
    const [selectedGenericasSistema, setSelectedGenericasSistema] = useState([]);

    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [metadataGenericaSistemaRef, setMetadataGenericaSistemaRef] = useState([]);

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [genericaSistema, setGenericaSistema] = useState(emptyGenericaSistemaInit);
    const [selectAll, setSelectAll] = useState(false);

    const [genericasSistema, setGenericasSistema] = useState(null);

    const lazyParamInit = {
        first: 0,
        rows: 5,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }

    };

    const [isOnPage, SetIsOnPage] = useState(false);

    const [isLazy, setIsLazy] = useState(props.selectionMode !== 'multivalue');
    const [isLazyLock, setIsLazyLock] = useState(false);

    const [lazyParams, setLazyParams] = useState(undefined);

    const lazyParamsInitSelected = useRef(Object.assign({}, lazyParamInit));
    const [comodin, setComodin] = useState(0);

    addLocale('es', {
        startsWith: 'Inicia con',
        contains: 'Contiene',
        notContains: 'No contiene',
        endsWith: 'Termina en',
        equals: 'Igual',
        notEquals: 'Diferente',
        noFilter: 'Sin filtro',
        filter: 'Filtro',
        lt: 'Menor que',
        lte: 'Menor o igual a',
        gt: 'Mayor que',
        gte: 'Mayor o igual a',
        dateIs: 'Fecha es',
        dateIsNot: 'Fecha no es',
        dateBefore: 'Fecha es anterior',
        dateAfter: 'Fecha es posterior',
        custom: 'Persolizados',
        clear: 'Limpiar',
        close: 'Cerrar',
        apply: 'Aplicar',
        matchAll: 'Coinciden todos',
        matchAny: 'Coincide alguno',
        addRule: 'Agregar regla',
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    locale('es');


    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasModulo.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto)[0]);
    }

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    useEffect(() => {
        if (props.etiquetasModulo === undefined || props.etiquetasModulo === null || props.etiquetasModulo.length === 0)
            LoadEtiquetas();

    }, [])

    const LoadEtiquetas = async => {

        plantillaService.getEtiquetasModulo(codModulo, idEmpresa, idioma, "DataTableListGegnerica").then(data => {
            setEtiquetasModulo(data);
        });

    }

    if ((props.selectedTipoGenerica !== undefined && selectedTipoGenerica === undefined) || props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
    }
    else {

        let newSelectedTipoGenerica = undefined;

        if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            SetIsOnPage(false);
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, filtroUts: { ...props.selectedTipoGenerica.filtroUts } };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema(null);
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {
            SetIsOnPage(false);
            let newSelectedTipoGenerica2 = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica2);
            setGenericasSistema(null);
        }

    }

    useEffect(() => {
        //console.log("entró useEffect", selectedTipoGenerica);
        let tg = selectedTipoGenerica.tg === undefined ? "" : selectedTipoGenerica.tg;

        if (tg !== "") {
            LoadDatosGenerica(tg, idEmpresa, idioma, userName);
        }

    }, [selectedTipoGenerica])

    const LoadDatosGenerica = async (tg, idEmpresa, idioma, userName) => {

        lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        setSelectedGenericasSistema(null);

        await genericaSistemaService.getMetadataGenericasSistema(tg, idEmpresa, idioma, userName).then(data => {

            let columnaIdentificadorOculta = "tg";
            let prefijo = '000000';
            let TamSufijo = 4;

            if (data.length > 0 && data[0].orden !== undefined) {

                data = data.sort(function (a, b) {
                    let a1 = (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                    let b1 = (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                    return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                });
            }

            data = data.map(x => ({ ...x, columnRef: null }));

            let ctiTextoCampoRef = "ctiTexto";

            if (props.metadataRef.refCampoTg !== undefined) {

                let metadataCampoTg = data.find(col => col.campo === props.metadataRef.refCampoTg);
                let newMetadataCampoTg;
                let index;

                if (metadataCampoTg !== undefined) {
                    newMetadataCampoTg = { ...metadataCampoTg };
                    newMetadataCampoTg.ctiTexto = "Cód.";

                    index = data.indexOf(metadataCampoTg);
                    data.splice(index, 1, newMetadataCampoTg);
                }

                metadataCampoTg = data.find(col => col.campo === `ctiTexto${props.metadataRef.refCampoTg}`);

                if (metadataCampoTg !== undefined) {

                    ctiTextoCampoRef = metadataCampoTg.campo

                    newMetadataCampoTg = { ...metadataCampoTg };

                    newMetadataCampoTg.ctiTexto = "Nombre.";

                    index = data.indexOf(metadataCampoTg);
                    data.splice(index, 1, newMetadataCampoTg);
                }

            }

            let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);
            //console.log("metadataImprimible, ", metadataImprimible, "metadataRef, ", props.metadataRef)

            let columnsDefault = []

            if (props.metadataRef !== undefined && props.metadataRef.camposFiltroRef !== undefined && props.metadataRef.camposFiltroRef !== null && props.metadataRef.camposFiltroRef !== "") {
                columnsDefault = props.metadataRef.camposFiltroRef.replace(' ', '').split(',');
            }
            else {
                columnsDefault = [props.metadataRef.refCampoTg, ctiTextoCampoRef]
            }

            //console.log("columnsDefault, ",columnsDefault);

            let newSelectedColumns = metadataImprimible.filter(col => columnsDefault.includes(col.campo))


            let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

            //let dataForm = metadataImprimible.map(x=> ({...x, formRef : null, mensajeError : ""}));

            //let newSelectedColumns=metadataImprimible.filter(col => col.campo!==columnaIdentificadorOculta )

            if (props.aplicaSearchTextBase && props.campoSearchTextBase !== undefined && props.campoSearchTextBase !== "") {
                let campoSearch = data.find(x => x.campo === props.campoSearchTextBase);
                setCtiTextoSearchTextBase(campoSearch.ctiTexto);
            }

            if (dataRef.length > 0) {

                //setSelectedColumns([]);

                lazyParamInit.filters = createHeaderGenerica(metadataImprimible);
                let newLazyParamInit = Object.assign({}, lazyParamInit);
                setIsLazyLock(false);

                setMetadataGenericaSistema(data);
                setLazyParams(newLazyParamInit);
                lazyParamsInitSelected.current = newLazyParamInit;
                setSelectedColumns(newSelectedColumns);
                //console.log("data, ", data, ", newLazyParamInit, ", newLazyParamInit, ", newSelectedColumns, ", newSelectedColumns);
            }

        });

    }

    const onBooleanChange = (e, campo) => {

        const val = (e.checked && e.checked) || false;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistema.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    const onInputChange = (e, campo) => {


        const val = (e.target && e.target.value) || '';
        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistema.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);
    }

    const onInputNumberChange = (e, campo) => {
        const val = e.value || 0;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistema.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedGenericasSistema(value);

        if (props.selectionMode !== 'multivalue' && props.onSelectedItem) {
            props.onSelectedItem(value, props.metadataRef);
        }
        else if (props.onSelectedItemes)
            props.onSelectedItemes(value, props.metadataRef);
    }

    useEffect(() => {

        if (lazyParams !== undefined && selectedTipoGenerica !== undefined && isLazyLock === false) {
            //console.log("llamó hpe,",selectedTipoGenerica, lazyParams);
            loadLazyData();
        }

    }, [lazyParams]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadLazyData = () => {
        setLoading(true);

        if (selectedTipoGenerica.tg !== undefined && selectedTipoGenerica.tg !== "") {

            let filtroUtsDominioDato = props.filtroUtsDominioDato || '';

            if (filtroUtsDominioDato !== "" && selectedTipoGenerica.variableRestriccionExterna != undefined && selectedTipoGenerica.variableRestriccionExterna != "") {

                Object.keys(selectedTipoGenerica.variableRestriccionExterna).forEach(k => {
                    let campoExterno = k.toUpperCase();
                    filtroUtsDominioDato = filtroUtsDominioDato.replace(campoExterno, "'" + selectedTipoGenerica.variableRestriccionExterna[k]['valor'] + "'");
                });

            }

            let filtroUts = { ...selectedTipoGenerica.filtroUts };

            if (props.aplicaSearchTextBase && props.campoSearchTextBase !== undefined && props.campoSearchTextBase !== "") {
                filtroUts[props.campoSearchTextBase] = searchTextBase !== "" ? searchTextBase : "%$#%&/@";
            }

            console.log("filtroUtsDominioDato, ", filtroUtsDominioDato);
            let newlazyParams = { ...lazyParams, isLazy: isLazy }

            genericaSistemaService.GetAllGenericasSistemaDependiente(selectedTipoGenerica.tg, props.metadataRef.tg, props.metadataRef.referenciaRef, { lazyEvent: JSON.stringify(newlazyParams) }, idEmpresa, idioma, userName, filtroUts, filtroUtsDominioDato).then(data => {
                //genericaSistemaService.GetAllGenericasSistemaDependiente(selectedTipoGenerica.tg, props.metadataRef.tg, props.metadataRef.referenciaRef, { lazyEvent: JSON.stringify(newlazyParams) }, idEmpresa, idioma, userName, undefined, filtroUtsDominioDato).then(data => {
                //setMetadataGenericaSistema(data.metadata);
                setGenericasSistema(data.data)

                if (metadataGenericaSistema.length < data.metadata.length) {

                    let ctiTextoCampoRef = "ctiTexto";

                    setMetadataGenericaSistema(data.metadata);
                    let metadataImprimible = data.metadata.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                    let columnsDefault = []

                    if (props.metadataRef !== undefined && props.metadataRef.camposFiltroRef !== undefined && props.metadataRef.camposFiltroRef !== null && props.metadataRef.camposFiltroRef !== "") {
                        columnsDefault = props.metadataRef.camposFiltroRef.replace(' ', '').split(',');
                    }
                    else {
                        columnsDefault = [props.metadataRef.refCampoTg, ctiTextoCampoRef]
                    }

                    //console.log("columnsDefault, ",columnsDefault);

                    let newSelectedColumns = metadataImprimible.filter(col => columnsDefault.includes(col.campo))


                    setSelectedColumns(newSelectedColumns);
                }

                setTotalRecords(previo => previo < 0 ? data.totalRecord : data.totalRecord);
                setLoading(false);

                if (isLazy === false) {
                    setIsLazyLock(true);
                }

                if (isOnPage === false && props.initialSelectedItemes !== null && props.initialSelectedItemes !== undefined && props.initialSelectedItemes !== "") {

                    let itemes = props.initialSelectedItemes.split(",");
                    let selectedItemes = data.data.filter(x => itemes.includes(x.uts[props.metadataRef.refCampoTg]));

                    console.log("selectedItemes, ", selectedItemes);
                    setSelectedGenericasSistema(selectedItemes);

                }
                else if (isOnPage) {
                    SetIsOnPage(false);
                }

            });

        }
        else {
            setGenericasSistema([])
            setTotalRecords(0);
            setLoading(false);
            SetIsOnPage(false);
        }

    }

    const onPage = (event) => {
        SetIsOnPage(true);
        setLazyParams(event);
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    const ColumnFilterTemplate = (options) => {


        //const campo =  selectedColumns.find(et => et.campo ===options.field);
        //const metadataRef =  metadataGenericaSistemaRef.find(et => et.campo ===options.field);

        let campo = options.field.replace("uts.", "");
        let field = options.field;

        const metadata = metadataGenericaSistema.find(et => et.campo === campo);
        const metaColumn = selectedColumns.find(et => et.campo === campo);

        const lazyParamCampo = Object.keys(lazyParams.filters).includes(field) ? lazyParams.filters[`${field}`] : null;
        const val = lazyParamCampo !== null ? lazyParamCampo.value : "";

        switch (metadata.tipoDato) {
            case "boolean": return <TriStateCheckbox id={`filter${metadata.tg + '-' + metadata.campo}`} value={options.value} onChange={(e) => onfilterapply(options, e)} />; break;
            //case "int": return ( <InputNumber id = {`filter${metadata.tg+'-'+metadata.campo}`} placeholder="Search..."  style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e) }  />); break;
            //case "double": return ( <InputNumber id = {`filter${metadata.tg+'-'+metadata.campo}`} placeholder="Search..." mode="decimal" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e) }  />); break;
            default: return (<InputText id={`filter${metadata.tg + '-' + metadata.campo}`} ref={e => metaColumn.columnRef = e} placeholder="Search..." type="search" style={{ paddingLeft: '0.5rem', minWidth: '5rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} />); break;
        }

    }

    const onfilterapply = (options, event) => {

        options.filterApplyCallback(event.target.value);
        /*if (isLazy) {
            
        }
        
        else{
            options.filterCallback(event.target.value)
        }*/

    }

    const columnBodyTemplate = (tipoDato, formatoDato) => {

        if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA_RA" && formatoDato === "ACA_UNIDAD_RA_CRITERIO_NIVEL") {
            return selectButtonBodyTemplate;
        }

        switch (tipoDato) {
            case 'boolean':
                return booleanBodyTemplate

            case 'double':
                return doubleBodyTemplate
            case 'int':
                return formatoDato === "money" ? moneyBodyTemplate : intBodyTemplate
            case 'money':
                return moneyBodyTemplate
            //case 'tags':return tagsBodyTemplate
            case 'text':
                return textRichBodyTemplate
            //case 'date':return dateBodyTemplate
            //case 'color':return colorBodyTemplate
            //case 'file':return fileBodyTemplate
            default:
                {
                    if (tipoDato === 'ref' && formatoDato === 'ACA_UNIDAD_RA_CRITERIO_NIVEL') return selectButtonBodyTemplate;
                    else
                        return textBodyTemplate;
                }
        }
    }

    const booleanBodyTemplate33 = (rowData, column) => {

        let campo = column.field.replace("uts.", "");

        let metadata = undefined;

        metadata = metadataGenericaSistema.find(x => x.campo === campo);

        let val = false;
        if (metadata) {
            val = rowData.uts[campo];
        }

        return <i className={classNames('pi', { 'true-icon pi-check-circle': val, 'false-icon pi-times-circle': !val })}></i>;
    }

    const textBodyTemplate33 = (rowData, column) => {

        let campo = column.field.replace("uts.", "");
        let metadata = undefined;

        metadata = metadataGenericaSistema.find(x => x.campo === campo);


        let val = "";
        if (metadata) {
            val = rowData.uts[campo];
        }

        return <div style={{ maxWidth: "100%", wordBreak: "break-word", color: "black" }} dangerouslySetInnerHTML={{ __html: val }} />
        //return <span >{val}</span>;
    }

    const booleanBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = (typeof rowData.uts[column.field] === "boolean") ? rowData.uts[column.field] : typeof rowData.uts[column.field] === "string" ? rowData.uts[column.field].toLowerCase() === "true" : false;
        }

        if (val === true) {
            return (<i className={classNames('pi', val === true ? 'true-icon pi-check-circle' : 'false-icon pi-times-circle')} style={{ color: 'green' }} ></i>);
        }
        else {
            return (<i className={classNames('pi', val === true ? 'true-icon pi-check-circle' : 'false-icon pi-times-circle')} style={{ color: 'red' }} ></i>);
        }

        //return (<Checkbox checked={val} readOnly className='surface-300' ></Checkbox>);
    }

    const doubleBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = 0.00;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toFixed(2)}</span>;
    }

    const intBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = 0;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{Math.trunc(val)}</span>;
    }

    const moneyBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}</span>;
    }

    const textBodyTemplate = (rowData, column) => {

        let val = "";
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        if (metadata) {
            val = rowData.uts[column.field];
        }

        let valTexto = "";
        if (metadata) {
            valTexto = rowData.uts[column.field];
        }
        let tamMaximoVisibleFila = 80;
        let mostrarBoton = (valTexto !== undefined && valTexto !== null && valTexto !== "" && valTexto.length > tamMaximoVisibleFila);
        val = mostrarBoton ? valTexto.substring(0, tamMaximoVisibleFila) + "[...]" : valTexto;

        let esValido = !validaData ? true : (!metadata.esRequerido ? true : (val !== "" && val !== undefined && val !== null));

        if (!esValido) {

            return (<div className='p-invalid-cell '> <i className="pi pi-times-circle" style={{ color: "red" }}></i> &nbsp;</div>);

        }
        else {
            return (
                <>
                    {
                        (function () {
                            //rounded text raised                         
                            if (mostrarBoton) return <Button style={{ width: '2rem', height: '2rem' }} size="small" icon="pi pi-external-link" className="p-button-rounded" aria-label="Ver más" onClick={() => { setDialogText(valTexto); setDialogTextVisible(true); }} />
                        })()
                    }

                    <div style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: val }} />


                </>
            );
        }
        //<span style={{ maxWidth: "5rem", wordBreak: "break-word" }} >{val}</span>
    }

    const textRichBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let valTexto = "";
        if (metadata) {
            valTexto = rowData.uts[column.field];
        }
        let tamMaximoVisibleFila = 80;
        let mostrarBoton = (valTexto !== undefined && valTexto !== null && valTexto !== "" && valTexto.length > tamMaximoVisibleFila);
        let val = mostrarBoton ? valTexto.substring(0, tamMaximoVisibleFila) + "[...]" : valTexto;

        return (
            <>
                {
                    (function () {
                        //rounded text raised
                        if (mostrarBoton) return <Button style={{ width: '2rem', height: '2rem' }} size="small" icon="pi pi-external-link" className="p-button-rounded" aria-label="Ver más" onClick={() => { setDialogText(valTexto); setDialogTextVisible(true); }} />
                    })()
                }

                <div style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: val }} />



            </>
        );
    }

    const ConvertTipoDatoADateTypeTabla = (tipoDato) => {

        let res = "text";

        switch (tipoDato) {
            case "date": res = "date"; break;
            case "int": res = "numeric"; break;
            case "double": res = "numeric"; break;
            case "boolean": res = "boolean"; break;
            default: res = "text"; break;
        }

        return res;
    }



    //return <Column key={k.campo}  field={k.campo} header={ k.ctiTexto } sortable filter filterPlaceholder="Buscar por xyz" />;
    const columnsDataTable = selectedColumns.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0).map(k => {
        return <Column key={k.campo} field={k.campo} header={k.ctiTexto} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
            //body={k.tipoDato === "boolean" ? booleanBodyTemplate : "boolean" ? intBody: textBodyTemplate} 
            body={columnBodyTemplate(k.tipoDato, k.formatoDato)}
            sortable
            //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
            filter filterElement={ColumnFilterTemplate}
            filterPlaceholder="Buscar por xyz" />;
    });

    const columnsDataTableNoLazy = selectedColumns.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0).map(k => {
        return <Column key={k.campo} field={`uts.${k.campo}`} header={k.ctiTexto} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
            body={k.tipoDato === "boolean" ? booleanBodyTemplate : textBodyTemplate} sortable
            //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
            filter filterElement={ColumnFilterTemplate}
            filterPlaceholder="Buscar por xyz" />;
    });

    

    const clearFilter1 = () => {
        initFilters1();
    }

    const aplicarFiltro = () => {
        buscarFilter1();
    }

    const onColumnToggle = (event) => {

        let newselectedColumns = event.value;

        let orderedSelectedColumns = metadataGenericaSistema.filter(col => newselectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0));

        setSelectedColumns(orderedSelectedColumns);
    }

    const header = (
        <div className="">

            <h5 className="m-0">{GetTextoEtiqueta("LABEL_MANAGE")} - {selectedTipoGenerica !== undefined && selectedTipoGenerica.ctiTexto ? selectedTipoGenerica.ctiTexto : ""}</h5>

            <div className="flex flex-row-reverse flex-wrap card-container yellow-container">
                <span className="block mt-2 md:mt-0 p-input-icon-left">
                    <i className="pi pi-search" />

                    <MultiSelect value={selectedColumns}
                        options={metadataGenericaSistema.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0)}
                        optionLabel="ctiTexto" onChange={onColumnToggle} style={{ with: '10em' }} />

                </span>

            </div>
        </div>

    );


    const clickSearchTextBase = () => {
        setLazyParams({ ...lazyParams });
    };

    const renderHeader = () => {
        if (props.aplicaSearchTextBase && props.campoSearchTextBase !== undefined && props.campoSearchTextBase !== "") {
            return (
                <div className="flex justify-content-start">
                    <label  >{ctiTextoSearchTextBase}</label>
                    <InputText value={searchTextBase} onChange={(e) => setSearchTextBase(e.target.value)} placeholder="" />
                    <Button icon="pi pi-search" label='Buscar' rounded aria-label="Buscar" onClick={clickSearchTextBase} />
                </div>
            );
        }
        else return (<></>);

    };





    const createHeaderGenerica = (objecto) => {

        let headers = "";
        let preCampo = isLazy ? "" : "uts.";

        //Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&')

        objecto.forEach(function (meta, indice, array) {
            if (indice > 0) {
                headers += ',';
            }
            else {
                headers += '{';
            }

            switch (meta.tipoDato) {
                case "int": headers += `"${preCampo + meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "double": headers += `"${preCampo + meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "money": headers += `"${preCampo + meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "date": headers += `"${preCampo + meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "string": headers += `"${preCampo + meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                default: headers += `"${preCampo + meta.campo}":{ "value": "", "matchMode": "contains","ref": null }`; break;
            }

        });

        headers += '}';

        return (JSON.parse('' + headers + ''));
    }


    const initFilters1 = () => {
        setLazyParams(Object.assign({}, lazyParamsInitSelected.current));
        //setGlobalFilterValue2('');
    }

    const buscarFilter1 = () => {
        setLazyParams(Object.assign({}, lazyParams));
        //setGlobalFilterValue2('');
    }

    const arrayTemplate = Array.from({ length: 5 });
    const bodyTemplate = () => {
        return <Skeleton></Skeleton>
    }


    if (lazyParams === undefined || selectedTipoGenerica === undefined || !selectedTipoGenerica.tg || !selectedTipoGenerica.tg === "" || metadataGenericaSistema.length == 0) {

        return (<DataTable value={arrayTemplate} className="p-datatable-striped" header={bodyTemplate}>
            <Column field="code" header="Code" style={{ width: '25%' }} body={bodyTemplate}></Column>
            <Column field="name" header="Name" style={{ width: '25%' }} body={bodyTemplate}></Column>
        </DataTable>)
    }

    else {

        return (
            <DataTable lazy={isLazy} value={genericasSistema} dataKey="indexRow" filterDisplay="row" ref={dt} style={{ width: '100%', height: '100%' }}
                header={renderHeader}
                paginator first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25]}
                onPage={onPage} size="small"
                onFilter={onFilter} filters={lazyParams.filters} loading={loading}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                onSelectionChange={onSelectionChange} selectionMode={props.selectionMode !== 'multivalue' ? 'single' : 'checkbox'} // selectionMode="single"
                resizableColumns
                selection={selectedGenericasSistema}
                //selectAll={selectAll} 
                //onSelectAllChange={onSelectAllChange}
                //globalFilter={globalFilter} 
                emptyMessage={GetTextoEtiqueta("LABEL_EMPTY_MESSAGE")}
                className="datatable-responsive"
                responsiveLayout="scroll"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
            >
                {props.selectionMode == 'multivalue' ? <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> : <></>}
                {isLazy ? columnsDataTable : columnsDataTableNoLazy}

            </DataTable>
        );
    }

});

/*const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(DataTableGenerica, comparisonFn);*/
export default DataTableListGenerica;

